import React from "react";
import { camelCase } from "lodash";
import shortid from 'shortid'
import contactData from "../../content-data/contact/contacts.json";


const CorporateMailingAddress = () => {
    return contactData.offices.map((office) => (
            <div key={shortid.generate()} className={`${camelCase(office.city)}`}>
                <div className="bg" />
                <div className="inner">
                    <h2 className="cityName">Corporate Mailing Address</h2>

                    <address>
                        <div className="knowledge">
                            {office.addressStrings.map((addressString) =>(
                                <span key={shortid.generate()}>
                                    {addressString}
                                    <br/>
                                </span>
                            ))}
                        </div>
                    </address>
                </div>
            </div>
        ))
}

export default CorporateMailingAddress;